import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const useCases = ['Customer security reviews', 'SOC 2 readiness', 'ISO 27001 readiness', 'Cyber-insurance renewals', 'Board updates', 'Investor diligence', 'Internal security reviews', 'MSSP client reporting', 'AI app security reviews', 'Remediation proof', 'Security QBRs', 'Vendor diligence', 'M&A assessments'];
const packContents = ['Executive summary', 'Top validated attack paths', 'AI-security validation results', 'Evidence for each path', 'Business impact', 'Remediation plan', 'Verification status', 'Residual risk', 'Control observations', 'Change since last report', 'Technical appendix', 'Shareable summary'];
export function Evidence() {
  return <section id="evidence" className="relative w-full py-32 border-t border-white/5" data-id="element-319">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-320">
        <SectionLabel number="12" label="Evidence" className="mb-8" data-id="element-321" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-322">
          <div className="lg:col-span-8" data-id="element-323">
            <SectionHeading size="xl" data-id="element-324">
              Security proof
              <br data-id="element-325" />
              <span className="text-white/40" data-id="element-326">you can actually use.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-327">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-328">
              Periscan helps teams move from screenshots and assertions to
              validated evidence — designed for both technical and non-technical
              audiences.
            </p>
          </div>
        </div>

        {/* Use cases tags */}
        <div className="mb-20" data-id="element-329">
          <p className="font-mono text-xs uppercase tracking-widest text-white/40 mb-6" data-id="element-330">
            Use Periscan evidence for
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-331">
            {useCases.map((uc, i) => <motion.span key={i} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.03
          }} className="px-4 py-2 text-sm text-white/80 bg-white/[0.03] hover:bg-white/[0.06] border border-white/5 rounded-full transition-colors" data-id="element-332">
                {uc}
              </motion.span>)}
          </div>
        </div>

        {/* Evidence pack */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-333">
          <div className="lg:col-span-5" data-id="element-334">
            <h3 className="text-3xl md:text-4xl font-semibold text-white tracking-tight mb-6 leading-tight" data-id="element-335">
              What is in a Periscan Evidence Pack?
            </h3>
            <div className="space-y-3 mt-8" data-id="element-336">
              <div className="flex items-center gap-3 py-2" data-id="element-337">
                <div className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4]" data-id="element-338" />
                <span className="text-base text-white" data-id="element-339">
                  Security teams get{' '}
                  <span className="text-white/60" data-id="element-340">evidence</span>.
                </span>
              </div>
              <div className="flex items-center gap-3 py-2" data-id="element-341">
                <div className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4]" data-id="element-342" />
                <span className="text-base text-white" data-id="element-343">
                  Executives get <span className="text-white/60" data-id="element-344">clarity</span>.
                </span>
              </div>
              <div className="flex items-center gap-3 py-2" data-id="element-345">
                <div className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4]" data-id="element-346" />
                <span className="text-base text-white" data-id="element-347">
                  Customers get{' '}
                  <span className="text-white/60" data-id="element-348">confidence</span>.
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-349">
            <div className="rounded-2xl bg-gradient-to-br from-[#0a0d12] to-[#070a0e] border border-white/5 overflow-hidden" data-id="element-350">
              <div className="px-6 py-4 border-b border-white/5 flex items-center justify-between" data-id="element-351">
                <span className="font-mono text-xs uppercase tracking-widest text-white/40" data-id="element-352">
                  Evidence Pack Contents
                </span>
                <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-353">
                  {packContents.length} items
                </span>
              </div>
              <div className="divide-y divide-white/5" data-id="element-354">
                {packContents.map((item, i) => <motion.div key={i} initial={{
                opacity: 0,
                x: -5
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.3,
                delay: i * 0.03
              }} className="px-6 py-3 flex items-center gap-4 hover:bg-white/[0.02] transition-colors" data-id="element-355">
                    <span className="font-mono text-xs text-white/30 w-6" data-id="element-356">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="text-sm text-white/80" data-id="element-357">{item}</span>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}